import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var SplitIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.2546C2 3.46078 3.46078 2 5.2546 2H24C24.5786 2 25.0476 2.46904 25.0476 3.04762V44.9524C25.0476 45.531 24.5786 46 24 46H5.2546C3.46078 46 2 44.5392 2 42.7454V5.2546ZM5.2546 4.09524C4.61795 4.09524 4.09524 4.61795 4.09524 5.2546V42.7454C4.09524 43.382 4.61795 43.9048 5.2546 43.9048H22.9524V4.09524H5.2546Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9524 3.04762C22.9524 2.46904 23.4214 2 24 2H42.7454C44.5392 2 46 3.46078 46 5.2546V42.7454C46 44.5392 44.5392 46 42.7454 46H24C23.4214 46 22.9524 45.531 22.9524 44.9524V3.04762ZM25.0476 4.09524V43.9048H42.7454C43.382 43.9048 43.9048 43.382 43.9048 42.7454V5.2546C43.9048 4.61795 43.382 4.09524 42.7454 4.09524H25.0476Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3754 20.0465C14.7845 19.6374 15.4478 19.6374 15.857 20.0465L19.0697 23.2592C19.2661 23.4557 19.3765 23.7222 19.3765 24C19.3765 24.2778 19.2661 24.5443 19.0697 24.7408L15.857 27.9535C15.4478 28.3626 14.7845 28.3626 14.3754 27.9535C13.9663 27.5444 13.9663 26.881 14.3754 26.4719L16.8473 24L14.3754 21.5281C13.9663 21.119 13.9663 20.4556 14.3754 20.0465Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67111 24C7.67111 23.4214 8.14015 22.9524 8.71873 22.9524H18.3289C18.9075 22.9524 19.3765 23.4214 19.3765 24C19.3765 24.5786 18.9075 25.0476 18.3289 25.0476H8.71873C8.14015 25.0476 7.67111 24.5786 7.67111 24Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6246 20.0465C34.0337 20.4556 34.0337 21.119 33.6246 21.5281L31.1527 24L33.6246 26.4719C34.0337 26.881 34.0337 27.5444 33.6246 27.9535C33.2155 28.3626 32.5522 28.3626 32.143 27.9535L28.9303 24.7408C28.7339 24.5443 28.6235 24.2778 28.6235 24C28.6235 23.7222 28.7339 23.4557 28.9303 23.2592L32.143 20.0465C32.5522 19.6374 33.2155 19.6374 33.6246 20.0465Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6235 24C28.6235 23.4214 29.0925 22.9524 29.6711 22.9524H39.2813C39.8599 22.9524 40.3289 23.4214 40.3289 24C40.3289 24.5786 39.8599 25.0476 39.2813 25.0476H29.6711C29.0925 25.0476 28.6235 24.5786 28.6235 24Z"
  }));
});
SplitIcon.displayName = 'SplitIcon';
SplitIcon.defaultProps = {
  'aria-label': 'Split'
};
export default SplitIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/SplitIcon/index.js
// module id = 1942
// module chunks = 12